// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.11111 6.9375C7.11111 4.22234 9.28827 2 12 2C14.7117 2 16.8889 4.22234 16.8889 6.9375C16.8889 9.65266 14.7117 11.875 12 11.875C9.28827 11.875 7.11111 9.65266 7.11111 6.9375ZM1 17.0625C1 14.3473 3.17716 12.125 5.88889 12.125C8.60062 12.125 10.7778 14.3473 10.7778 17.0625C10.7778 19.7777 8.60062 22 5.88889 22C3.17716 22 1 19.7777 1 17.0625ZM13.2222 17.0625C13.2222 14.3473 15.3994 12.125 18.1111 12.125C20.8228 12.125 23 14.3473 23 17.0625C23 19.7777 20.8228 22 18.1111 22C15.3994 22 13.2222 19.7777 13.2222 17.0625Z"}}]};

const Palette1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'palette-1-filled',
    ref,
    icon: element,
  },
));

Palette1FilledIcon.displayName = 'Palette1FilledIcon';

export default Palette1FilledIcon;
